import React from 'react';
import { Drawer,Input,Radio,Icon,Form,Alert,Button } from 'antd';
import NHFormItem from "../../common/NHFormItem";
import {hasAuth} from "../../../utils/NHCore";
import getSize from "../../../utils/getSize"
import { Scrollbars } from 'react-custom-scrollbars'
import NHInputRender from "../../common/NHInputPicker/render";
import NHUpload from '../../../utils/NHUpload'

const TextArea = Input.TextArea;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
class DrawerShowForm extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            zfd:this.props.initJfcsData.ZFD?this.props.initJfcsData.ZFD:"0",   //支付端
            show:this.props.initJfcsData.ZFFS == '1' ? true : false,   //是否展示图片参数
        }
    }

    componentDidMount(){

    }

    handleZfd = (e) =>{
        this.setState({zfd:e.target.value})
    }

    onChangeRadio =(e)=>{
        if (e.target.value == '1'){
            this.setState({
                show:true
            })
        } else {
            this.setState({
                show:false
            })
        }
    }

    render() {
        const { title,visible,handleCancel,handleDrawerBtnClick,initPtcsData,initJfcsData,form} = this.props;
        const { show } = this.state;
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 12, offset: 6},
                md: {span: 10, offset: 7},
            }
        };
        let formItems = [];
        if(initPtcsData.length>0){
            let tempItems = [];
            tempItems.push((
                <FormItem {...tailFormItemLayout} key={title}>
                    <p style={{fontWeight: 'bold', fontSize: 16, borderBottom: '1px solid #efefef'}}>
                        <Icon type="setting"/>{title}
                    </p>
                </FormItem>
            ));
            //渲染参数设置项
            for (let param of initPtcsData) {
                let formItem = (
                    <NHInputRender key={param.DJCSZID} id={param.DJCSZID} label={param.ZDMC} value={param.CSZ}
                                   form={form}
                                   feature={param.BDKJCS}/>);
                tempItems.push(formItem);
            }
            formItems = formItems.concat(tempItems);
        }else {
            formItems.push((
                <FormItem {...tailFormItemLayout} key={"info"}>
                    <Alert message="暂无参数设置项，请到参数设置项里添加！" type="info" showIcon/>
                </FormItem>
            ));
        }
        return (
            <Scrollbars autoHide style={{ width: '100%', height: getSize().windowH - 103 }}>
                <div>
                    <Form>
                        <div style={{display:'none'}}>
                            <NHFormItem id={'djfsid'} form={form} initialValue={initJfcsData?initJfcsData.DJFSID:null}>
                                <Input />
                            </NHFormItem>
                        </div>
                        <NHFormItem label="对接方式名称" id={'djfsmc'} form={form} initialValue={initJfcsData?initJfcsData.DJFSMC:null}>
                            <Input disabled={true}/>
                        </NHFormItem>
                        <NHFormItem label="支付端" id={'zfd'} form={form} initialValue={initJfcsData.ZFD?initJfcsData.ZFD:"0"} required={true}>
                            <RadioGroup onChange={this.handleZfd}>
                                <Radio value={"0"}>不支付</Radio>
                                <Radio value={"1"}>PC端</Radio>
                                <Radio value={"2"}>移动端</Radio>
                                <Radio value={"12"}>PC端和移动端</Radio>
                            </RadioGroup>
                        </NHFormItem>
                        {
                            this.state.zfd=="1"||this.state.zfd=="12"?<NHFormItem label="PC支付路径" id={'pczflj'} form={form} initialValue={initJfcsData.PCZFLJ?initJfcsData.PCZFLJ:null} required={true}>
                                <Input placeholder={'请输入PC支付路径...'} style={{ width:'350px' }}/>
                            </NHFormItem>:null
                        }
                        {
                            this.state.zfd=="2"||this.state.zfd=="12"?<NHFormItem label="移动支付路径" id={'ydzflj'} form={form} initialValue={initJfcsData.YDZFLJ?initJfcsData.YDZFLJ:null} required={true}>
                                <Input placeholder={'请输入移动支付路径...'} style={{ width:'350px' }}/>
                            </NHFormItem>:null
                        }
                        <NHFormItem label="是否可以编辑缴费金额" id={'sfkybjjrfje'} form={form} initialValue={initJfcsData.SFKYBJJRFJE?initJfcsData.SFKYBJJRFJE:"0"} required={true}>
                            <RadioGroup>
                                <Radio value={"0"}>不可以编辑</Radio>
                                <Radio value={"1"}>可以编辑</Radio>
                            </RadioGroup>
                        </NHFormItem>
                        <NHFormItem label="缴费情况来源" id={'jfqkly'} form={form} initialValue={initJfcsData.JFQKLY?initJfcsData.JFQKLY:""}>
                            <RadioGroup>
                                <Radio value={"0"}>中间库</Radio>
                                <Radio value={"1"}>第三方接口</Radio>
                            </RadioGroup>
                        </NHFormItem>
                        <NHFormItem label="支付方式" id={'zffs'} form={form} initialValue={initJfcsData.ZFFS?initJfcsData.ZFFS:""} >
                            <RadioGroup onChange={this.onChangeRadio}>
                                <Radio value={"0"}>路径跳转</Radio>
                                <Radio value={"1"}>二维码图片</Radio>
                                <Radio value={"2"}>第三方提供二维码生成方式</Radio>
                            </RadioGroup>
                        </NHFormItem>
                        {show?
                            <NHFormItem label="二维码" form={form} id={'qrcode'} initialValue={initJfcsData.QRCODE?initJfcsData.QRCODE:""}>
                                <NHUpload
                                    image={true}
                                    fileCountLimit={1}
                                    listType="picture-card"
                                    serviceMark={'sm-yxxt'} //服务标志，说明是属于哪个服务
                                    moduleName={'迎新系统'}  //模块名称，说明是属于哪个服务的哪个模块\
                                    isEdit={true}
                                />
                            </NHFormItem>
                            :
                            null
                        }
                        <NHFormItem label="支付提示" id={'zfts'} form={form} initialValue={initJfcsData.ZFTS?initJfcsData.ZFTS:null}>
                            <TextArea placeholder={'请输入支付提示...'} style={{ width:'350px' }} rows={3}/>
                        </NHFormItem>
                        {formItems}
                        <div style={{textAlign:"center"}}>
                            <Button type="primary" onClick={handleDrawerBtnClick} >提交</Button>
                        </div>
                    </Form>
                </div>
            </Scrollbars>
        );
    }
}

const DrawerForm = Form.create()(DrawerShowForm);
export default DrawerForm;


// WEBPACK FOOTER //
// ./components/zxjfgl/jffagl/drawerShowForm.js